(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    if (window.__floatingAtcControllerInitialized) return;
    window.__floatingAtcControllerInitialized = true;

    const showAll = () => {
      document.querySelectorAll('[data-floating-atc]').forEach((el) => el.setAttribute('data-floating-visible', 'true'));
    };

    const hideAll = () => {
      document.querySelectorAll('[data-floating-atc]').forEach((el) => el.removeAttribute('data-floating-visible'));
    };

    let scrollTimeout;
    let lastScrollTop = window.scrollY;

    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      if (Math.abs(currentScrollTop - lastScrollTop) < 2) return;

      showAll();
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        hideAll();
      }, 600);

      lastScrollTop = currentScrollTop;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
